import { buildSort, goPromise } from "@delanobgt/admin-core/util/helpers";
import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { CancelTokenSource } from "axios";
import _ from "lodash";
import { ApiClientFactory } from "@delanobgt/admin-core/util/types";

import {
  EBnibProductSortField,
  IBnibProduct,
  PBnibProductFilter,
} from "../entities";
import IBnibProductRepository from "../repository";

export default class BnibProductRepository
  implements IBnibProductRepository<CancelTokenSource> {
  private apiClientFactory: ApiClientFactory;

  // api routes
  private BNIB_PRODUCT_ROUTE = "/admin/bnib-product";

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClientFactory = apiClientFactory;
  }

  buildFilter = (filter: PBnibProductFilter) => {
    let price =
      filter.price_gte && filter.price_lte
        ? `${filter.price_gte},${filter.price_lte}`
        : undefined;

    const clonedFilter = { ...filter };

    return _.pickBy(
      {
        ...clonedFilter,
        price,
      },
      Boolean
    );
  };

  private getSignalToken(signal: CancelTokenSource) {
    return _.get(signal, "token", null);
  }

  private getError(error: any) {
    return _.get(error, "response.data.errors", "Something went wrong.");
  }

  async getBnibProduct(
    userId: number,
    pagination: IPagination,
    filter: PBnibProductFilter,
    sorts: ISort<EBnibProductSortField>[],
    signal?: CancelTokenSource
  ): Promise<[IBnibProduct[], IMeta]> {
    const sort = buildSort(sorts);
    const params = _.pickBy(
      {
        seller_id: userId,
        ...pagination,
        ...this.buildFilter(filter),
      },
      (val) => val
    );
    const [err, response] = await goPromise(
      this.apiClientFactory({ cancelToken: this.getSignalToken(signal) }).get(
        `${this.BNIB_PRODUCT_ROUTE}?sort=${sort}`,
        {
          params,
        }
      )
    );
    if (err) {
      throw this.getError(err);
    }
    const { data, meta } = response.data;
    return [data, meta];
  }

  async getBnibProductByCode(code: string): Promise<IBnibProduct> {
    const [err, response] = await goPromise(
      this.apiClientFactory().get(`${this.BNIB_PRODUCT_ROUTE}/${code}`)
    );
    if (err) {
      throw this.getError(err);
    }
    return response.data;
  }
}
